// extracted by mini-css-extract-plugin
module.exports = {"container":"data-layer-menu_container__H82G7"};